import React, { useCallback } from 'react';
import { gql } from '@urql/core';
import { PlayerSocialDisplaysFragment } from 'generated/spin-graphql';
import { ExternalLink } from '../../common/ExternalLink';
import { FacebookIcon } from '../../svg/socials/FacebookIcon';
import { TwitterIcon } from '../../svg/socials/TwitterIcon';
import { InstagramIcon } from '../../svg/socials/InstagramIcon';
import { YoutubeIcon } from '../../svg/socials/YoutubeIcon';
import { TikTokIcon } from '../../svg/socials/TikTokIcon';
import { TwitchIcon } from '../../svg/socials/TwitchIcon';

type Props = {
    social: PlayerSocialDisplaysFragment;
};

gql`
    fragment PlayerSocialDisplays on espin_social {
        discord
        twitter
        facebook
        tiktok
        instagram
        youtube_channel {
            id
            link_data
        }
        twitch_channel {
            id
            link_data
        }
    }
`;

export const PlayerSocialDisplays: React.FC<Props> = ({ social }) => {
    const getYTLink = useCallback((linkData: string) => {
        console.log('linkData', linkData);
        if (linkData.startsWith('c/') || linkData.startsWith('channel/') || linkData.startsWith('user/')) {
            return linkData;
        }
        if (linkData.startsWith('@')) {
            return linkData;
        }
        return `/results?search_query=${linkData}`;
    }, []);
    return (
        <div className="socials-container">
            {social?.facebook && (
                <ExternalLink
                    className="social-icon"
                    ariaLabel={'Facebook'}
                    link={
                        social.facebook.startsWith('http') ? social.facebook : `https://facebook.com/${social.facebook}`
                    }
                    icon={<FacebookIcon />}
                />
            )}
            {social?.twitter && (
                <ExternalLink
                    className="social-icon"
                    ariaLabel={'Twitter'}
                    link={`https://www.twitter.com/${social.twitter}`}
                    icon={<TwitterIcon />}
                />
            )}
            {social?.instagram && (
                <ExternalLink
                    className="social-icon"
                    ariaLabel={'Instagram'}
                    link={
                        social.instagram.startsWith('http') // https, etc
                            ? social.instagram // just show it
                            : social.instagram.startsWith('@') // @ user id
                            ? `https://www.instagram.com/${social.instagram.split('@').pop()}` // pop the @ and show it
                            : `https://www.instagram.com/${social.instagram}` // show at the end of insta
                    }
                    icon={<InstagramIcon />}
                />
            )}
            {social?.youtube_channel && (
                <ExternalLink
                    className="social-icon"
                    ariaLabel={'YouTube'}
                    link={`https://www.youtube.com/${getYTLink(social.youtube_channel.link_data)}`}
                    icon={<YoutubeIcon />}
                />
            )}
            {social?.tiktok && (
                <ExternalLink
                    className="social-icon"
                    ariaLabel={'TikTok'}
                    link={`https://www.tiktok.com/${social?.tiktok}`}
                    icon={<TikTokIcon />}
                />
            )}
            {social?.twitch_channel && (
                <ExternalLink
                    className="social-icon"
                    ariaLabel={'Twitch'}
                    link={`https://www.twitch.tv/${social?.twitch_channel.link_data}`}
                    icon={<TwitchIcon />}
                />
            )}
        </div>
    );
};
